/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_EmptyInputs */

const cs_signing_empty = /** @type {(inputs: Signing_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné dokumenty k podpisu. Vytvořte žádost z oprávněného PDF v DMS, nebo vygenerujte protokol z úkolu prohlídky.`)
};

const en_signing_empty = /** @type {(inputs: Signing_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No signing documents yet. Create a request from an eligible DMS PDF, or generate a viewing protocol from a viewing task.`)
};

/**
* | output |
* | --- |
* | "No signing documents yet. Create a request from an eligible DMS PDF, or generate a viewing protocol from a viewing task." |
*
* @param {Signing_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_empty = /** @type {((inputs?: Signing_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_empty(inputs)
	return cs_signing_empty(inputs)
});